// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/typographyStyle
import { container } from 'styles/jss/original/base';

const styles = {
  container,
  textQuote: {
    paddingBottom: '10px',
    '@media (max-width: 640px)': {
      '& blockquote': {
        padding: '10px'
      },
      '& p': {
        lineHeight: '1.5em'
      }
    }
  }
};

export default styles;
